import { writable, get } from "svelte/store";
import jwt_decode from "jwt-decode";
import { BackgroundService } from "../services/BackgroundService.js";
import { LocalStorage } from "../services/LocalStorage.js";
import { ActiveTopicStore } from "./extension/ActiveTopicStore.ts";
import { AUTH_NAME, LoginService } from "./../services/LoginService.js";

const LoginServiceImpl = chrome?.storage ? BackgroundService : LoginService;

const init = async () => {
    if (!get(TokenStore).initialized) {
        // if auth exists in storage, set required values to this store
        try {
            const auth = await LoginServiceImpl.getAuth();
            updateTokenStore(auth);

            // auth doesn't exist in storage or refresh token is expired
        } catch (error) {
            TokenStore.update((token) => {
                return { ...token, expired: true, initialized: true };
            });
            return;
        }

        TokenStore.update((token) => {
            return { ...token, initialized: true };
        });
    }
};

const updateTokenStore = (auth) => {
    let expired = LoginService.isExpired(auth.exp);
    const decodedToken = jwt_decode(auth.token);

    TokenStore.update((token) => {
        return {
            ...token,
            expired,
            token: auth.token,
            user: auth.user,
            intercomToken: auth.intercomToken,
            decodedToken,
        };
    });
};

const updateTokenStoreUser = async (user) => {
    TokenStore.set({ user: user });
    const refreshedToken = await LoginServiceImpl.refreshTokenLogin();
    TokenStore.updateTokenStore(refreshedToken);
};

const clearStores = () => {
    ActiveTopicStore.clear();
    TokenStore.set({
        expired: true,
        initialized: true,
        user: undefined,
        token: undefined,
        intercomToken: undefined,
        decodedToken: undefined,
    });
};

const store = () => {
    // create store
    const { subscribe, set, update } = writable({
        expired: true,
        initialized: false,
        user: undefined,
        token: undefined,
        intercomToken: undefined,
        decodedToken: undefined,
    });

    return {
        subscribe,
        set,
        update,
        init: init,
        updateTokenStore: updateTokenStore,
        updateTokenStoreUser: updateTokenStoreUser,
        refreshToken: async () => {
            const refreshedToken = await LoginServiceImpl.refreshTokenLogin();
            updateTokenStore(refreshedToken);
        },
        logout: async () => {
            // logout from intercom and sleekplan
            window.Intercom ? window.Intercom("shutdown") : "";
            await LocalStorage.remove("_sleek_product");

            // clear stores
            await LocalStorage.remove(AUTH_NAME);

            clearStores();
        },
    };
};

export const TokenStore = store();

LocalStorage.subscribe(AUTH_NAME, (localAuth) => {
    if (localAuth.newValue) {
        updateTokenStore(localAuth.newValue);
    } else {
        clearStores();
    }
});
